import { useEffect, useState } from 'react';
import { hysteriFetch } from 'hysterics';
import { useRequestData } from 'wsm-common-data';

const NR_PREFIX = 'MYCARS_VDP';
const ENDPOINT_FETCH_ERROR = `${NR_PREFIX}/CLIENT/VEHICLES_ENDPOINT_FETCH_ERROR`;

const vehicleDataService = hysteriFetch('vehicleData', {
	timeout: {
		timeout: 2000
	}
});

const newrelicAction = (action, facets) => {
	if (window && window.newrelic && typeof window.newrelic === 'object') {
		window.newrelic.addPageAction(action, facets);
	}
};

export const useFetchVehicleData = ({
	vehicleId,
	siteId,
	accountId,
	enableMyCars
}) => {
	const { deviceType, locale } = useRequestData();
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);

	const fetchVehicleData = async () => {
		const requestUrl = `/api/widget/ws-mycars-vdp/vehicles/${vehicleId}`;

		const requestBody = {
			siteId,
			locale,
			deviceType,
			accountId
		};

		const requestBodyStringified = JSON.stringify(requestBody);

		let inventoryResponse;

		try {
			inventoryResponse = await vehicleDataService(requestUrl, {
				method: 'POST',
				headers: {
					'content-type': 'application/json;charset=UTF-8'
				},
				body: requestBodyStringified
			});

			setResponse(inventoryResponse);
		} catch (e) {
			setError(e);
			newrelicAction(`${ENDPOINT_FETCH_ERROR}`, {
				requestUrl,
				error: e
			});
			throw new Error(`${ENDPOINT_FETCH_ERROR}: ${e.message}`);
		}
	};

	useEffect(() => {
		if (vehicleId && enableMyCars) {
			fetchVehicleData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vehicleId, enableMyCars]);

	return { response, error };
};
